module.exports = __webpack_public_path__ + "img/ads-recommendition.415def04.svg";